import { useQuery } from '@tanstack/react-query';
import { listUsers } from '../lib/dailyApi';
import { getUserProfile } from '../lib/usersApi';

/** Load active team members for the daily-summary user selector. */
export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: listUsers,
    staleTime: 10 * 60 * 1000,
  });
}

/**
 * One colleague's profile card (chat roster). Kept fresh-ish: the workload
 * half changes as tasks move, so the default 60s stale time applies.
 */
export function useUserProfile(userId: string | null) {
  return useQuery({
    queryKey: ['users', userId, 'profile'],
    queryFn: () => getUserProfile(userId as string),
    enabled: Boolean(userId),
  });
}
